"use client";

var __jsx = React.createElement;
import React, { useState, useEffect } from "react";
import entityBrandingStoryblokService from "@lib/storyblok/services/financial-entity-services/entity-branding-service";
import Image from "next/image";
import { cn } from "@lib/cn";
const PlatformLogo = _ref => {
  let {
    height,
    className,
    containerClassName,
    useContrastIcon = false,
    dataTestId,
    width
  } = _ref;
  const {
    0: src,
    1: setSrc
  } = useState(null);
  useEffect(() => {
    const getUrl = async () => {
      const srcGetter = useContrastIcon ? await entityBrandingStoryblokService.getPlatformContrastLogo() : await entityBrandingStoryblokService.getPlatformLogo();
      setSrc(srcGetter);
    };
    getUrl();
  }, []);
  return src ? __jsx("div", {
    "data-testid": dataTestId,
    className: cn("relative", containerClassName),
    style: {
      height,
      width: width ? width : "auto"
    }
  }, __jsx(Image, {
    className: className,
    src: src,
    fill: true,
    objectFit: "contain",
    alt: "Platform Logo",
    loading: "eager"
  })) : null;
};
export default PlatformLogo;